import { isError } from 'lodash';

export const parseServiceError = (event: { type: string; data?: unknown }): string =>
  !!event.data && isError(event.data) ? event.data.message : 'Something went wrong';

export const setError = <TState extends string>(
  state: TState,
  context: { errors: object; [k: string]: any },
  event: { type: string; data?: unknown },
) => ({
  ...context.errors,
  [state]: parseServiceError(event),
});

export const setFlag = <TFlags>(
  flag: keyof TFlags,
  context: { flags: TFlags; [k: string]: any },
  value: boolean,
) => ({
  ...context.flags,
  [flag]: value,
});
